/* istanbul ignore file reason: test due in next card WM-3143 */

export abstract class BaseDateValue {
  constructor(public value: string) {}

  abstract format(): string;
}

export class DateValue extends BaseDateValue {
  format() {
    return getDate(this.value);
  }
}

export class TimeValue extends BaseDateValue {
  format() {
    return getTime(this.value);
  }
}

export class DateTimeValue extends BaseDateValue {
  format() {
    return getDateTime(this.value);
  }
}

function getDate(value: string) {
  const date = new Date(value);
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
}
function getTime(value: string) {
  const date = new Date(value);
  return `${date.getHours()}:${date.getMinutes()}`;
}
function getDateTime(value: string) {
  return `${getDate(value)} ${getTime(value)}`;
}
